module.exports = __webpack_public_path__ + "static/media/costco.e43ea371.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/where-to-buy/costco.jpg
// module id = 1317
// module chunks = 0